import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import AppV1 from './AppV1';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element #root not found in index.html');
}
createRoot(container).render(
  <StrictMode>
    <AppV1 />
  </StrictMode>,
);
